<template lang="pug">
Page(title="Influencer Plans", :items="items")
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "Dashboard", url: "/influencer/plans/dashboard" },
        { title: "Monthly", url: "/influencer/plans/monthly" },
        { title: "Search", url: "/influencer/plans/search" },
      ],
    };
  },
};
</script>
